import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function KnowledgeSearch() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const handleSearch = async () => {
    if (!searchTerm.trim()) return;
    setLoading(true);
    setSearched(true);
    try {
      const resp = await fetch(`${API_URL}/api/knowledge/search?q=${encodeURIComponent(searchTerm)}`);
      const data = await resp.json();
      if (data.success) {
        setResults(data.results || []);
      }
    } catch (e) {
      console.error('搜索失败', e);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className="knowledge-container">
      <div className="kb-browse-header">
        <button className="kb-back-btn" onClick={() => navigate('/knowledge')}>
          ← 返回
        </button>
        <h2>🔍 全局搜索</h2>
      </div>

      <div className="kb-search-box">
        <input
          type="text"
          placeholder="输入关键词搜索所有知识库..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleKeyDown}
          className="kb-search-input kb-search-input-lg"
          autoFocus
        />
        <button 
          className="kb-search-btn" 
          onClick={handleSearch}
          disabled={loading || !searchTerm.trim()}
        >
          {loading ? '搜索中...' : '搜索'}
        </button>
      </div>

      {!searched ? (
        <div className="kb-search-tips">
          <p>💡 搜索所有云端知识库中的问题、答案、产品版本、模块信息</p>
          <div className="kb-search-hints">
            <span className="kb-hint" onClick={() => { setSearchTerm('库存'); handleSearch(); }}>库存管理</span>
            <span className="kb-hint" onClick={() => { setSearchTerm('采购订单'); handleSearch(); }}>采购订单</span>
            <span className="kb-hint" onClick={() => { setSearchTerm('预算'); handleSearch(); }}>预算</span>
            <span className="kb-hint" onClick={() => { setSearchTerm('合并报表'); handleSearch(); }}>合并报表</span>
          </div>
        </div>
      ) : (
        <div className="kb-search-results">
          <p className="kb-result-count">
            {loading ? '搜索中...' : `找到 ${results.length} 条结果`}
          </p>
          {results.map((item, idx) => (
            <div 
              key={idx} 
              className="kb-item-card"
              onClick={() => navigate(`/knowledge/browse/${encodeURIComponent(item.source)}`)}
              style={{ cursor: 'pointer' }}
            >
              <div className="kb-item-source">📂 {item.source}</div>
              <div className="kb-item-q">❓ {item.q || '未知问题'}</div>
              <div className="kb-item-a">💡 {item.a ? (item.a.length > 200 ? item.a.substring(0, 200) + '...' : item.a) : '无答案'}</div>
              <div className="kb-item-meta">
                {item.product && <span className="kb-tag">{item.product}</span>}
                {item.module && <span className="kb-tag kb-tag-module">{item.module}</span>}
                {item.time && <span className="kb-tag-time">{item.time}</span>}
              </div>
            </div>
          ))}
          {results.length === 0 && !loading && (
            <div className="kb-empty">没有找到相关结果，换个关键词试试</div>
          )}
        </div>
      )}
    </div>
  );
}
